import Vue from 'vue';

export const fetchMemberPaymentPlans = async ({ commit }) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: '/payment-plans/member',
    });
    commit('setMemberPaymentPlans', data.paymentPlans || []);
    return data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

export const fetchPaymentPlanDetail = async ({ commit }, planId) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: `/payment-plans/${planId}`,
    });
    commit('setCurrentPaymentPlan', {
      ...data.paymentPlan,
      currentAttempt: data.currentAttempt || null,
    });
    return data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

export const fetchNextInstallment = async ({ commit }, planId) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: `/payment-plans/${planId}/next-installment`,
    });
    commit('setNextInstallment', data.installment);
    return data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

export const processInstallmentPayment = async (_, payload) => {
  try {
    const { data } = await Vue.axios({
      method: 'POST',
      url: '/payments/partial-payment/process',
      data: payload,
    });
    return data;
  } catch (error) {
    const msg =
      error.response?.data?.error?.message || error.message;
    return { status: false, message: msg };
  }
};

export const confirmInstallmentCardPayment = async (_, paymentData) => {
  try {
    const { data } = await Vue.axios({
      method: 'POST',
      url: '/payments/card/confirm',
      data: { payment: paymentData },
    });
    return data;
  } catch (error) {
    const msg =
      error.response?.data?.error?.message || error.message;
    return { status: false, message: msg };
  }
};
